"use client"

import { useEffect, useMemo, useState, useContext, useRef } from "react"
import { useTenantNavigation } from "../../../hooks/useTenantNavigation"
import { ErpContext } from "../../../context/ErpContext.js"
import { ApiContextDominios } from "../../../context/apiContextDominios.js"
import Cookies from "js-cookie"

import {
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography,
  Grid,
  Autocomplete,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Switch,
  FormControlLabel,
  useMediaQuery,
  useTheme,
  alpha,
} from "@mui/material"
import { styled } from "@mui/material/styles"

import DeleteIcon from "@mui/icons-material/Delete"
import SwapHorizIcon from "@mui/icons-material/SwapHoriz"
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner"
import ReceiptIcon from "@mui/icons-material/Receipt"
import PersonIcon from "@mui/icons-material/Person"
import PaymentsIcon from "@mui/icons-material/Payments"
import SaveIcon from "@mui/icons-material/Save"

const roundToTwoDecimals = (value) => {
  return Math.round(value * 100) / 100
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  "&.MuiTableCell-head": {
    backgroundColor: "#5b5b5f",
    color: theme.palette.common.white,
    fontWeight: 600,
  },
  "&.MuiTableCell-body": {
    fontSize: 13,
  },
}))

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:hover": {
    backgroundColor: alpha(theme.palette.primary.light, 0.1),
    transition: "background-color 0.2s ease",
  },
}))

const PreventaCrearComponent = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"))
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"))
  const isMobileOrTablet = isMobile || isTablet
  const navigate = useTenantNavigation()

  const { user } = useContext(ErpContext)

  const {
    getItemTresLetras,
    itemTresLetras,
    clearItemTresLetras,
    getEntidadesClientesTresLetras,
    entidadesClientesTresLetras,
    getEntidadByID,
    getListaMontosByIdItemIdEntidad,
    getTop10ItemVentas,
    postTransaccion,
    postTransaccionItem,
    getUbicacion,
    ubicaciones,
    getNegocio,
    negocios,
  } = useContext(ApiContextDominios)

  const [tipoModalOpen, setTipoModalOpen] = useState(false)
  const [tipoSeleccionado, setTipoSeleccionado] = useState("preventa")
  const [isScannerActive, setIsScannerActive] = useState(false)
  const [scannerError, setScannerError] = useState(null)
  const [scannedCode, setScannedCode] = useState(null)
  const [isScanning, setIsScanning] = useState(false)
  const [scannerReader, setScannerReader] = useState(null)
  const [scannerInitialized, setScannerInitialized] = useState(false)
  const [videoDevices, setVideoDevices] = useState([])
  const [selectedDeviceId, setSelectedDeviceId] = useState("")

  const [descripcionTransaccion, setDescripcionTransaccion] = useState("")
  const [searchText, setSearchText] = useState("")
  const [searchTextCliente, setSearchTextCliente] = useState("")
  const [selectedItem, setSelectedItem] = useState(null)
  const [itemList, setItemList] = useState([])
  const [cantidadInputs, setCantidadInputs] = useState({})
  const [precioInputs, setPrecioInputs] = useState({})
  const [topVentasItems, setTopVentasItems] = useState([])

  const [dniCliente, setDniCliente] = useState(null)
  const [selectedUbicacion, setSelectedUbicacion] = useState(null)
  const [selectedNegocio, setSelectedNegocio] = useState(null)
  const videoRef = useRef(null)

  const total = useMemo(() => {
    return roundToTwoDecimals(
      itemList.reduce((acc, it) => acc + it.cantidad * it.precio, 0),
    )
  }, [itemList])

  const opcionesItems = useMemo(() => {
    if (searchText.length >= 3) {
      return itemTresLetras || []
    }
    return topVentasItems || []
  }, [searchText, itemTresLetras, topVentasItems])

  useEffect(() => {
    const init = async () => {
      const ubicacionTraida = await getUbicacion()
      const negocioTraido = await getNegocio()

      try {
        const defaultEntidad = await getEntidadByID(1)
        if (defaultEntidad) {
          setDniCliente({
            label: `${defaultEntidad.descripcion} ${defaultEntidad.apellido} ${defaultEntidad.dniCuitCuil}`,
            ...defaultEntidad,
          })
        }
      } catch (error) {
        console.log("No se pudo cargar el cliente por defecto:", error)
      }

      try {
        const top10items = await getTop10ItemVentas()
        if (top10items) {
          const mappedTop10 = top10items.map(({ item }) => ({
            id: item.id,
            codigo: item.codigo,
            descripcion: item.descripcion,
            codigoScanner: item.codigoScanner,
          }))
          setTopVentasItems(mappedTop10)
        }
      } catch (error) {
        console.log("No se pudieron cargar los top items:", error)
        setTopVentasItems([])
      }

      const defaultUbicacion = ubicacionTraida?.find((it) => it.id === 1)
      const defaultNegocio = negocioTraido?.find((it) => it.id === 1)
      if (defaultUbicacion) {
        setSelectedUbicacion({ id: defaultUbicacion.id, label: defaultUbicacion.descripcion })
      }
      if (defaultNegocio) {
        setSelectedNegocio({ id: defaultNegocio.id, label: defaultNegocio.descripcion })
      }
    }

    init()
  }, [])

  useEffect(() => {
    const initInputs = {}
    const initPrecios = {}
    itemList.forEach((it) => {
      initInputs[it.idItem] = it.cantidad.toString()
      initPrecios[it.idItem] = it.precio.toString()
    })
    setCantidadInputs(initInputs)
    setPrecioInputs(initPrecios)
  }, [itemList])

  useEffect(() => {
    if (searchText.length >= 3) {
      clearItemTresLetras()
      getItemTresLetras(searchText)
    } else {
      clearItemTresLetras()
    }
  }, [searchText])

  useEffect(() => {
    if (searchTextCliente.length >= 3) {
      getEntidadesClientesTresLetras(searchTextCliente, 1)
    }
  }, [searchTextCliente])

  const handleAddItem = async (itemToAdd = null) => {
    const item = itemToAdd || selectedItem
    if (!item) return

    const cantidad = 1
    const idEntidad = dniCliente?.id || 1
    const idUbicacion = selectedUbicacion?.id || 1

    let precio = 0
    try {
      const precioLista = await getListaMontosByIdItemIdEntidad(
        idEntidad,
        item.id,
        idUbicacion,
      )
      precio = precioLista?.monto ?? 0
    } catch (error) {
      console.error("No se pudo obtener precio de lista:", error)
    }

    setItemList((prev) => {
      const existing = prev.find((it) => it.idItem === item.id)
      if (existing) {
        const updated = prev.map((it) =>
          it.idItem === item.id
            ? { ...it, cantidad: roundToTwoDecimals(it.cantidad + cantidad) }
            : it,
        )
        const moved = updated.find((it) => it.idItem === item.id)
        return moved ? [moved, ...updated.filter((it) => it.idItem !== item.id)] : updated
      }
      return [
        {
          idItem: item.id,
          codigo: item.codigo,
          descripcion: item.descripcion,
          cantidad,
          precio,
        },
        ...prev,
      ]
    })

    setSelectedItem(null)
    setSearchText("")
  }

  const handleCantidadChange = (idItem, value) => {
    setCantidadInputs((prev) => ({ ...prev, [idItem]: value }))
    const cantidad = Number.parseFloat(value.toString().replace(",", "."))
    if (!Number.isNaN(cantidad)) {
      setItemList((prev) =>
        prev.map((it) => (it.idItem === idItem ? { ...it, cantidad } : it)),
      )
    }
  }

  const handlePrecioChange = (idItem, value) => {
    setPrecioInputs((prev) => ({ ...prev, [idItem]: value }))
    const precio = Number.parseFloat(value.toString().replace(",", "."))
    if (!Number.isNaN(precio)) {
      setItemList((prev) =>
        prev.map((it) => (it.idItem === idItem ? { ...it, precio } : it)),
      )
    }
  }

  const handleRemoveItem = (idItem) => {
    setItemList((prev) => prev.filter((it) => it.idItem !== idItem))
  }

  const handleGuardarPreventa = async () => {
    if (itemList.length === 0) return

    const idEntidad = dniCliente?.id || 1
    const idUbicacion = selectedUbicacion?.id || 1
    const idNegocio = selectedNegocio?.id || 1
    const idUsuario =
      user?.id || Number.parseInt(Cookies.get("idUsuario") || "1", 10)

    const transaccionResponse = await postTransaccion(
      total,
      10,
      idEntidad,
      null,
      descripcionTransaccion,
      idUsuario,
      idUbicacion,
      idNegocio,
      0,
      0,
    )

    const idTransaccion = transaccionResponse?.data?.id
    if (!idTransaccion) return

    for (const it of itemList) {
      if (it.idItem && it.cantidad) {
        await postTransaccionItem(idTransaccion, it.idItem, it.cantidad, it.precio, 0)
      }
    }

    setItemList([])
    setDescripcionTransaccion("")
  }

  const handleConfirmTipo = () => {
    setTipoModalOpen(false)
  }

  const handleToggleScanner = () => {
    if (isScannerActive) {
      handleCloseScanner()
    } else {
      setIsScannerActive(true)
      setScannerError(null)
      setScannedCode(null)
    }
  }

  const loadVideoDevices = async () => {
    try {
      if (!navigator?.mediaDevices?.enumerateDevices) return
      const devices = await navigator.mediaDevices.enumerateDevices()
      const videoInputs = devices.filter((d) => d.kind === "videoinput")
      setVideoDevices(videoInputs)

      if (!selectedDeviceId && videoInputs.length > 0) {
        const preferred = videoInputs.find((d) =>
          String(d.label || "").toLowerCase().match(/back|rear|environment|trasera/),
        )
        setSelectedDeviceId(preferred?.deviceId || videoInputs[0].deviceId)
      }
    } catch (error) {
      console.warn("No se pudieron listar camaras:", error)
    }
  }

  const handleCloseScanner = () => {
    setIsScannerActive(false)
    setIsScanning(false)
    setScannerError(null)
    setScannedCode(null)
    setScannerInitialized(false)
    if (scannerReader) {
      try {
        scannerReader.reset()
      } catch (error) {
        console.warn("Error al resetear scanner:", error)
      }
      setScannerReader(null)
    }
  }

  const initializeScanner = async () => {
    if (scannerInitialized) return

    try {
      const { BrowserMultiFormatReader } = await import("@zxing/browser")
      const { BarcodeFormat, DecodeHintType } = await import("@zxing/library")
      const hints = new Map()
      hints.set(DecodeHintType.TRY_HARDER, true)
      hints.set(DecodeHintType.POSSIBLE_FORMATS, [
        BarcodeFormat.QR_CODE,
        BarcodeFormat.EAN_13,
        BarcodeFormat.EAN_8,
        BarcodeFormat.CODE_128,
        BarcodeFormat.CODE_39,
        BarcodeFormat.UPC_A,
        BarcodeFormat.UPC_E,
        BarcodeFormat.ITF,
        BarcodeFormat.DATA_MATRIX,
        BarcodeFormat.PDF_417,
      ])
      const reader = new BrowserMultiFormatReader(hints, 200)
      setScannerReader(reader)
      setScannerInitialized(true)

      const videoElement = videoRef.current || document.getElementById("scanner-video")
      if (!videoElement) {
        throw new Error("Elemento de video no encontrado")
      }

      await reader.decodeFromVideoDevice(
        selectedDeviceId || undefined,
        videoElement,
        (result, err) => {
          if (result) {
            handleCodeDetected(result.getText())
          }
          if (err && !err.message.includes("No MultiFormat Readers")) {
            console.warn("Error de escaneo:", err)
          }
        },
      )
      loadVideoDevices()
    } catch (error) {
      console.error("Error al inicializar escaner:", error)
      setScannerError("Error al acceder a la camara. Verifique los permisos.")
    }
  }

  const handleSelectCamera = (deviceId) => {
    setSelectedDeviceId(deviceId)
    setScannerInitialized(false)
    if (scannerReader) {
      try {
        scannerReader.reset()
      } catch (error) {
        console.warn("Error al resetear scanner:", error)
      }
    }
    if (isScannerActive) {
      setTimeout(() => initializeScanner(), 100)
    }
  }

  const handleToggleCamera = () => {
    if (!videoDevices.length) return
    const currentIndex = videoDevices.findIndex((d) => d.deviceId === selectedDeviceId)
    const nextIndex = currentIndex >= 0 ? (currentIndex + 1) % videoDevices.length : 0
    handleSelectCamera(videoDevices[nextIndex].deviceId)
  }

  useEffect(() => {
    if (isScannerActive) {
      loadVideoDevices()
    }
  }, [isScannerActive])

  useEffect(() => {
    if (isScannerActive && scannerInitialized) {
      // si cambia el device seleccionado, reiniciar lector
      if (scannerReader) {
        try {
          scannerReader.reset()
        } catch (error) {
          console.warn("Error al resetear scanner:", error)
        }
      }
      setScannerInitialized(false)
      const timer = setTimeout(() => {
        initializeScanner()
      }, 100)
      return () => clearTimeout(timer)
    }
  }, [selectedDeviceId])

  const handleCodeDetected = (code) => {
    if (isScanning) return
    setIsScanning(true)
    setScannedCode(code)
    console.log("Scanner detectado:", code)
    setSearchText(String(code || "").trim())
    handleCloseScanner()
  }

  useEffect(() => {
    if (isScannerActive && !scannerInitialized) {
      const timer = setTimeout(() => {
        initializeScanner()
      }, 100)
      return () => clearTimeout(timer)
    }
  }, [isScannerActive, scannerInitialized])

  const getClienteLabel = (option) => {
    if (!option?.descripcion) return ""
    return `${option.descripcion} ${option.apellido || ""} ${option.dniCuitCuil || ""}`.trim()
  }

  return (
    <Box
      sx={{
        p: isMobileOrTablet ? 1 : 2,
        pb: isMobileOrTablet ? 7 : 2,
        bgcolor: isMobileOrTablet ? "transparent" : "#f8f9fa",
        minHeight: isMobileOrTablet ? "auto" : "100vh",
      }}
    >
      {!isMobileOrTablet && (
        <Grid container spacing={2}>
          <Grid item xs={12} md={9}>
            <Card elevation={3} sx={{ mb: 2, borderRadius: 2 }}>
              <CardContent>
                <Typography variant="h6" sx={{ mb: 2, display: "flex", alignItems: "center" }}>
                  <ReceiptIcon sx={{ mr: 1, color: "rgb(244, 177, 14)" }} />
                  Detalle de Preventa
                </Typography>
                <Box sx={{ display: "flex", gap: 1, alignItems: "center", flexWrap: "wrap" }}>
                  <Autocomplete
                    fullWidth
                    sx={{ flexGrow: 1, minWidth: 320 }}
                    size="small"
                    options={opcionesItems}
                    value={selectedItem}
                    onChange={(event, newValue) => {
                      setSelectedItem(newValue)
                      if (newValue) handleAddItem(newValue)
                    }}
                    inputValue={searchText}
                    onInputChange={(event, newInputValue) => setSearchText(newInputValue)}
                    getOptionLabel={(option) =>
                      option?.descripcion ? `${option.codigo || ""} - ${option.descripcion}` : ""
                    }
                    renderInput={(params) => (
                      <TextField {...params} label="Buscar producto por codigo o descripcion" size="small" />
                    )}
                  />
                </Box>
              </CardContent>
            </Card>

            <Card elevation={3} sx={{ borderRadius: 2, overflow: "hidden" }}>
              <TableContainer sx={{ maxHeight: "calc(100vh - 250px)", minHeight: 420 }}>
                <Table stickyHeader size="small">
                  <TableHead>
                    <TableRow>
                      <StyledTableCell>Producto</StyledTableCell>
                      <StyledTableCell align="right">Cantidad</StyledTableCell>
                      <StyledTableCell align="right">Precio</StyledTableCell>
                      <StyledTableCell align="right">Total</StyledTableCell>
                      <StyledTableCell align="center">Accion</StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {itemList.length > 0 ? (
                      itemList.map((it) => (
                        <StyledTableRow key={it.idItem}>
                          <TableCell>{it.descripcion}</TableCell>
                          <TableCell align="right" sx={{ width: 130 }}>
                            <TextField
                              size="small"
                              value={cantidadInputs[it.idItem] || ""}
                              onChange={(e) => handleCantidadChange(it.idItem, e.target.value)}
                              sx={{ width: 110 }}
                            />
                          </TableCell>
                          <TableCell align="right" sx={{ width: 150 }}>
                            <TextField
                              size="small"
                              value={precioInputs[it.idItem] || ""}
                              onChange={(e) => handlePrecioChange(it.idItem, e.target.value)}
                              sx={{ width: 130 }}
                            />
                          </TableCell>
                          <TableCell align="right" sx={{ fontWeight: 700, color: "success.main" }}>
                            ${roundToTwoDecimals(it.cantidad * it.precio)}
                          </TableCell>
                          <TableCell align="center" sx={{ width: 80 }}>
                            <IconButton color="error" size="small" onClick={() => handleRemoveItem(it.idItem)}>
                              <DeleteIcon />
                            </IconButton>
                          </TableCell>
                        </StyledTableRow>
                      ))
                    ) : (
                      <StyledTableRow>
                        <TableCell colSpan={5} align="center" sx={{ py: 4, color: "text.secondary" }}>
                          No hay items cargados en la preventa
                        </TableCell>
                      </StyledTableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Card>
          </Grid>

          <Grid item xs={12} md={3}>
            <Card elevation={3} sx={{ mb: 2, borderRadius: 2 }}>
              <CardContent>
                <Typography variant="h6" sx={{ mb: 2, display: "flex", alignItems: "center" }}>
                  <PersonIcon sx={{ mr: 1, color: "rgb(244, 177, 14)" }} />
                  Datos Preventa
                </Typography>
                <FormControlLabel
                  control={
                    <Switch
                      checked={tipoSeleccionado === "venta"}
                      onChange={(e) => {
                        const isVenta = e.target.checked
                        setTipoSeleccionado(isVenta ? "venta" : "preventa")
                        if (isVenta) navigate("ventaCrear")
                      }}
                    />
                  }
                  label={tipoSeleccionado === "venta" ? "Venta" : "Preventa"}
                />
                <Autocomplete
                  fullWidth
                  size="small"
                  options={entidadesClientesTresLetras || []}
                  value={dniCliente}
                  onChange={(event, newValue) => setDniCliente(newValue)}
                  onInputChange={(event, newInputValue) => setSearchTextCliente(newInputValue)}
                  getOptionLabel={getClienteLabel}
                  renderInput={(params) => <TextField {...params} label="Cliente" size="small" />}
                  sx={{ mt: 1, mb: 1.5 }}
                />
                <FormControl fullWidth size="small" sx={{ mb: 1.5 }}>
                  <InputLabel>Ubicacion</InputLabel>
                  <Select
                    value={selectedUbicacion?.id || ""}
                    label="Ubicacion"
                    onChange={(e) => {
                      const id = Number(e.target.value)
                      const found = ubicaciones?.find((it) => it.id === id)
                      setSelectedUbicacion(found ? { id: found.id, label: found.descripcion } : null)
                    }}
                  >
                    {(ubicaciones || []).map((it) => (
                      <MenuItem key={it.id} value={it.id}>
                        {it.descripcion}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl fullWidth size="small">
                  <InputLabel>Negocio</InputLabel>
                  <Select
                    value={selectedNegocio?.id || ""}
                    label="Negocio"
                    onChange={(e) => {
                      const id = Number(e.target.value)
                      const found = negocios?.find((it) => it.id === id)
                      setSelectedNegocio(found ? { id: found.id, label: found.descripcion } : null)
                    }}
                  >
                    {(negocios || []).map((it) => (
                      <MenuItem key={it.id} value={it.id}>
                        {it.descripcion}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </CardContent>
            </Card>

            <Card elevation={3} sx={{ borderRadius: 2 }}>
              <CardContent>
                <Typography variant="h6" sx={{ mb: 2, display: "flex", alignItems: "center" }}>
                  <PaymentsIcon sx={{ mr: 1, color: "rgb(244, 177, 14)" }} />
                  Resumen
                </Typography>
                <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
                  <Typography variant="body2">Items</Typography>
                  <Typography variant="body2" fontWeight={700}>
                    {itemList.length}
                  </Typography>
                </Box>
                <Divider sx={{ mb: 1 }} />
                <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
                  <Typography variant="subtitle1" fontWeight={700}>
                    Total
                  </Typography>
                  <Typography variant="subtitle1" fontWeight={700} color="success.main">
                    ${total}
                  </Typography>
                </Box>
                <Button
                  fullWidth
                  variant="contained"
                  onClick={handleGuardarPreventa}
                  disabled={itemList.length === 0}
                  startIcon={<SaveIcon />}
                  sx={{
                    backgroundColor: "#5b5b5f",
                    color: "white",
                    "&:hover": { backgroundColor: alpha("rgb(244, 177, 14)", 0.8) },
                  }}
                >
                  Guardar Preventa
                </Button>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      )}

      {isMobileOrTablet && (
        <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 1,
          mb: 0.5,
        }}
      >
        <Box>
          <Typography variant="caption" color="text.secondary" sx={{ fontSize: 11 }}>
            Preventa
          </Typography>
        </Box>
        <Box sx={{ display: "flex", gap: 1 }}>
          <Button
            variant="outlined"
            startIcon={<SwapHorizIcon />}
            onClick={() => setTipoModalOpen(true)}
            size="small"
            sx={{ minHeight: 28, fontSize: 11, px: 1 }}
          >
            Configurar
          </Button>
        </Box>
      </Box>

      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Card>
            <CardContent sx={{ p: 1, "&:last-child": { pb: 1 } }}>
              <Grid container spacing={0.75} alignItems="center">
                <Grid item xs={12}>
                  <Box sx={{ display: "flex", gap: 0.5, alignItems: "center" }}>
                    <Autocomplete
                      fullWidth
                      size="small"
                      options={opcionesItems}
                      value={selectedItem}
                      onChange={(event, newValue) => {
                        setSelectedItem(newValue)
                        if (newValue) {
                          handleAddItem(newValue)
                        }
                      }}
                      inputValue={searchText}
                      onInputChange={(event, newInputValue) => setSearchText(newInputValue)}
                      getOptionLabel={(option) =>
                        option?.descripcion ? `${option.codigo || ""} - ${option.descripcion}` : ""
                      }
                      renderOption={(props, option) => (
                        <li {...props} style={{ fontSize: 11 }}>
                          {option?.descripcion ? `${option.codigo || ""} - ${option.descripcion}` : ""}
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Buscar item"
                          size="small"
                          sx={{ "& input": { fontSize: 11, py: 0.5 } }}
                          InputLabelProps={{ sx: { top: -2, fontSize: 13 } }}
                        />
                      )}
                    />
                    <IconButton
                      size="small"
                      sx={{ border: 1, borderColor: "divider", p: 0.5 }}
                      title="Escanear QR/Codigo"
                      onClick={handleToggleScanner}
                    >
                      <QrCodeScannerIcon fontSize="small" />
                    </IconButton>
                  </Box>
                </Grid>
              </Grid>

              <Table size="small" sx={{ "& td, & th": { py: 0.25, px: 0.5 } }}>
                <TableHead>
                  <TableRow sx={{ bgcolor: "grey.100" }}>
                    <TableCell sx={{ fontSize: 11 }}>Item</TableCell>
                    <TableCell sx={{ fontSize: 11 }}>
                      {isMobile ? "Cant." : "Cantidad"}
                    </TableCell>
                    <TableCell sx={{ fontSize: 11 }}>Precio</TableCell>
                    <TableCell sx={{ fontSize: 11 }}>Total</TableCell>
                    <TableCell />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {itemList.map((it) => (
                    <TableRow key={it.idItem}>
                      <TableCell sx={{ fontSize: 11 }}>{it.descripcion}</TableCell>
                      <TableCell sx={{ width: isMobile ? 70 : 110, py: 0.5 }}>
                        <TextField
                          size="small"
                          value={cantidadInputs[it.idItem] || ""}
                          onChange={(e) => handleCantidadChange(it.idItem, e.target.value)}
                          sx={{ "& input": { fontSize: 12, py: 0.5 } }}
                        />
                      </TableCell>
                      <TableCell sx={{ width: 110, py: 0.5 }}>
                        <TextField
                          size="small"
                          value={precioInputs[it.idItem] || ""}
                          onChange={(e) => handlePrecioChange(it.idItem, e.target.value)}
                          sx={{ "& input": { fontSize: 12, py: 0.5 } }}
                        />
                      </TableCell>
                      <TableCell sx={{ fontSize: 11, color: "success.main", fontWeight: 700 }}>
                        ${roundToTwoDecimals(it.cantidad * it.precio)}
                      </TableCell>
                      <TableCell>
                        <IconButton
                          color="error"
                          size="small"
                          sx={{ p: 0, width: 1, height: 1 }}
                          onClick={() => handleRemoveItem(it.idItem)}
                        >
                          <DeleteIcon fontSize="small" sx={{ width: 15, height: 15 }} />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      <Box
        sx={{
          position: "fixed",
          left: 0,
          right: 0,
          bottom: 0,
          px: isMobile ? 1 : 1.5,
          pt: 0.5,
          pb: 0.5,
          bgcolor: "background.paper",
          borderTop: 1,
          borderColor: "divider",
          zIndex: 1300,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 0.5,
          }}
        >
          <Typography variant="caption" sx={{ fontWeight: 700, fontSize: 11 }}>
            Items:{" "}
            <Box component="span" sx={{ color: "primary.main", fontWeight: 700 }}>
              {itemList.length}
            </Box>
          </Typography>
          <Typography variant="caption" sx={{ fontWeight: 700, fontSize: 11 }}>
            Total:{" "}
            <Box component="span" sx={{ color: "success.main", fontWeight: 700 }}>
              ${total}
            </Box>
          </Typography>
        </Box>
        <Button
          fullWidth
          variant="contained"
          onClick={handleGuardarPreventa}
          disabled={itemList.length === 0}
          size="small"
          sx={{ minHeight: 30, fontSize: 11 }}
        >
          Guardar Preventa
        </Button>
      </Box>
        </>
      )}

      <Modal open={tipoModalOpen} onClose={() => setTipoModalOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 1.5,
            borderRadius: 2,
            width: { xs: "90%", sm: 520 },
          }}
        >
          <Typography variant="subtitle2" sx={{ mb: 1 }}>
            Configuracion rapida
          </Typography>

          <Grid container spacing={1}>
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Switch
                    checked={tipoSeleccionado === "venta"}
                    onChange={(e) => {
                      const isVenta = e.target.checked
                      setTipoSeleccionado(isVenta ? "venta" : "preventa")
                      if (isVenta) {
                        setTipoModalOpen(false)
                        navigate("ventaCrear")
                      }
                    }}
                  />
                }
                label={tipoSeleccionado === "venta" ? "Venta" : "Preventa"}
              />
            </Grid>
            <Grid item xs={12}>
              <Autocomplete
                fullWidth
                size="small"
                options={entidadesClientesTresLetras || []}
                value={dniCliente}
                onChange={(event, newValue) => setDniCliente(newValue)}
                onInputChange={(event, newInputValue) => setSearchTextCliente(newInputValue)}
                getOptionLabel={getClienteLabel}
                renderOption={(props, option) => (
                  <li {...props} style={{ fontSize: 11 }}>
                    {getClienteLabel(option)}
                  </li>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Cliente"
                    size="small"
                    sx={{ "& input": { fontSize: 12 } }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth size="small">
                <InputLabel>Ubicacion</InputLabel>
                <Select
                  value={selectedUbicacion?.id || ""}
                  label="Ubicacion"
                  onChange={(e) => {
                    const id = Number(e.target.value)
                    const found = ubicaciones?.find((it) => it.id === id)
                    setSelectedUbicacion(found ? { id: found.id, label: found.descripcion } : null)
                  }}
                >
                  {(ubicaciones || []).map((it) => (
                    <MenuItem key={it.id} value={it.id}>
                      {it.descripcion}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth size="small">
                <InputLabel>Negocio</InputLabel>
                <Select
                  value={selectedNegocio?.id || ""}
                  label="Negocio"
                  onChange={(e) => {
                    const id = Number(e.target.value)
                    const found = negocios?.find((it) => it.id === id)
                    setSelectedNegocio(found ? { id: found.id, label: found.descripcion } : null)
                  }}
                >
                  {(negocios || []).map((it) => (
                    <MenuItem key={it.id} value={it.id}>
                      {it.descripcion}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
          <Divider sx={{ my: 0.75 }} />
          <Button
            fullWidth
            variant="contained"
            onClick={handleConfirmTipo}
            size="small"
            sx={{ minHeight: 30, fontSize: 11 }}
          >
            Cerrar
          </Button>
        </Box>
      </Modal>

      <Modal open={isScannerActive} onClose={handleCloseScanner}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 1.5,
            borderRadius: 2,
            width: { xs: "92%", sm: 420 },
          }}
        >
          <Typography variant="subtitle2" sx={{ mb: 1 }}>
            Escanear codigo
          </Typography>
          <Box sx={{ display: "flex", gap: 1, mb: 1 }}>
            <FormControl fullWidth size="small">
              <InputLabel>Camara</InputLabel>
              <Select
                value={selectedDeviceId || ""}
                label="Camara"
                onChange={(e) => handleSelectCamera(e.target.value)}
              >
                {videoDevices.length === 0 ? (
                  <MenuItem value="">Camara</MenuItem>
                ) : (
                  videoDevices.map((device, index) => (
                    <MenuItem key={device.deviceId} value={device.deviceId}>
                      {device.label || `Camara ${index + 1}`}
                    </MenuItem>
                  ))
                )}
              </Select>
            </FormControl>
            <Button
              variant="outlined"
              size="small"
              onClick={handleToggleCamera}
              disabled={videoDevices.length < 2}
              sx={{ minWidth: 90, fontSize: 11 }}
            >
              Cambiar
            </Button>
          </Box>
          <Box
            component="video"
            id="scanner-video"
            ref={videoRef}
            playsInline
            muted
            sx={{
              width: "100%",
              height: 280,
              bgcolor: "black",
              borderRadius: 1,
              mb: 1,
              objectFit: "cover",
            }}
          />
          {scannerError ? (
            <Typography variant="caption" color="error">
              {scannerError}
            </Typography>
          ) : null}
          {scannedCode ? (
            <Typography variant="caption" color="text.secondary" sx={{ display: "block" }}>
              Codigo detectado: <strong>{scannedCode}</strong>
            </Typography>
          ) : null}
          <Button
            fullWidth
            variant="contained"
            onClick={handleCloseScanner}
            size="small"
            sx={{ mt: 1, minHeight: 30, fontSize: 11 }}
          >
            Cerrar
          </Button>
        </Box>
      </Modal>
    </Box>
  )
}

export default PreventaCrearComponent
